<template>

    <div class="dmb-show-message">

        <h1 class="hero">
            <slot></slot>
        </h1>

        <button v-if="retryButton" @click="$emit('retry')">Opnieuw</button>

        <slot name="after"></slot>

    </div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'

export default Options({
    name: 'dmb-show-message',
    props: {
        retryButton: Boolean
    }
})(
    class ShowMessage extends Vue
    {

    }
)

</script>
<style src="../../scss/component/ShowMessage.scss" lang="scss"></style>